import { connect } from 'react-redux';

import { IState } from '../../store/index';
import { Features, IFeaturesProps } from './index';
import { FeaturesCommercial, IFeaturesCommercialProps } from './FeaturesCommercial';

export function mapStateToProps(state: IState): IFeaturesProps {
  return {
    offer: state.offerData.offer,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FeaturesContainer = connect<IFeaturesProps, any, any>(mapStateToProps)(Features);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FeaturesCommercialContainer = connect<IFeaturesCommercialProps, any, any>(mapStateToProps)(
  FeaturesCommercial,
);
